export default "__VITE_ASSET__CGSYdeNX__"